export { analytics } from "@/lib/analytics/analytics.facade";
export type { UseAxReturn } from "@/lib/analytics/analytics.hooks";
export { useAx } from "@/lib/analytics/analytics.hooks";
export {
  clearSignupMarker,
  hasSignupMarker,
  markSignupStart,
  SIGNUP_PENDING_STORAGE_KEY,
} from "@/lib/analytics/analytics.signup";
export type { AnalyticsTraits, EventProperties } from "@/lib/analytics/analytics.types";
